export const getRelatedFiles = (previousFiles, uploadedFiles, removedFiles) => {
  const previousFilesToUse = Array.isArray(previousFiles) ? previousFiles : []
  if (!Array.isArray(uploadedFiles) || !Array.isArray(removedFiles)) return previousFiles
  // Previous files informations filtered from files removed with sucess in ETL
  const successRemovedFiles = []
  removedFiles.forEach(file => {
    const { deletedStatus, ...restFile } = file
    if (deletedStatus === "success") successRemovedFiles.push(restFile)
  })
  const removeFilesNanoids = successRemovedFiles.map(file => file?.nanoid)
  const prevFilesWithoutRemoved = previousFilesToUse.filter(
    file => !removeFilesNanoids.includes(file?.nanoid)
  )
  // New files informations from files uploaded with success in ETL
  const successUploadedFiles = []
  uploadedFiles.forEach(file => {
    const { uploadStatus, ...restFile } = file
    if (uploadStatus === "success") successUploadedFiles.push(restFile)
  })

  // Final files informations to save in our object for database
  const relatedFiles = [...prevFilesWithoutRemoved, ...successUploadedFiles]

  return relatedFiles
}
